<template>
  <div class="navbar-container">
    <div
      class="announcement-bar"
      :class="{ 'announcement-bar--hidden': isScrolled }"
    >
      <div class="announcement-bar__inner">
        <LazyAnnouncement />
      </div>
    </div>
    <div
      class="header selected_container"
      :class="{
        scrolled: isScrolled,
        productShowcaseVisible: showProducts,
        hidden: $route.path.startsWith('/explore'),
      }"
    >
      <div class="left-side">
        <div class="menu-options">
          <button
            v-if="!menu"
            type="button"
            aria-label="Open menu"
            :aria-expanded="menu ? 'true' : 'false'"
            @click.stop="menu = true"
          >
            <RiMenu2Line />
          </button>
        </div>
        <NuxtLink
          v-if="!menu"
          external
          class="logo"
          to="/"
          aria-label="Go to Travvir home"
          >Travvir</NuxtLink
        >
        <NuxtLink
          to="/#book-a-demo"
          class="download-app-btn demo"
          aria-label="Book a demo"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#E864DA">
            <path
              d="M19,4H18V2H16V4H8V2H6V4H5C3.89,4 3,4.9 3,6V20A2,2 0 0,0 5,22H19A2,2 0 0,0 21,20V6A2,2 0 0,0 19,4M19,20H5V10H19V20M19,8H5V6H19V8Z"
            />
          </svg>
          <img src="~/public/book-a-demo.svg" alt="" >
        </NuxtLink>

        <div
          v-for="item in Object.keys(showcaseItems)"
          :key="item"
          class="nav-item-dropdown"
          @mouseenter="handleProductsHover(true, item)"
          @mouseleave="handleProductsHover(false, item)"
        >
          <button
            class="products-link"
            :class="{
              'active-products-hover': hoverElement === item && showProducts,
            }"
            @click.stop="handleProductsClick(item)"
          >
            {{ item }}
            <RiArrowDownSLine
              size="16px"
              :class="{
                'rotate-180': hoverElement === item && showProducts,
              }"
            />
          </button>
        </div>
        <!-- <NuxtLink to="/about" prefetch-on="visibility">About us</NuxtLink> -->
        <NuxtLink to="/docs" prefetch-on="visibility">Docs</NuxtLink>
        <!-- <NuxtLink
        to="/pricing"
        prefetch-on="visibility"
        v-if="miraStore?.country !== 'IN'"
        >Pricing</NuxtLink
      > -->

        <!-- <NuxtLink to="/partnership" prefetch-on="visibility"
        >Partnerships</NuxtLink
      > -->
        <NuxtLink to="/explore" prefetch-on="visibility"
          >Explore
          <span class="fire"
            ><img
              src="https://images.emojiterra.com/google/noto-emoji/unicode-16.0/color/svg/1f525.svg"
              alt="" ></span
        ></NuxtLink>
        <NuxtLink
          target="_blank"
          rel="noopener noreferrer"
          @click="handleOsBasedRedirection"
          >Login</NuxtLink
        >
      </div>
      <nav
        v-click-away="onClickAway"
        class="short-cut"
        :class="{ open: menu }"
        aria-label="Primary"
      >
        <!-- navigation -->
        <div class="top">
          <a
            v-if="showProducts"
            external
            class="logo products"
            to=""
            aria-label="Go to Travvir home"
            @click.stop="showProducts = false"
          >
            <RiArrowLeftLine size="20px" />
            {{ hoverElement }}
          </a>
          <NuxtLink
            v-if="!showProducts"
            external
            class="logo main-logo"
            to="/"
            aria-label="Go to Travvir home"
            >Travvir</NuxtLink
          >
          <button
            v-if="menu"
            class="icon"
            type="button"
            aria-label="Close menu"
            @click="closeMenu"
          >
            <RiCloseLine />
          </button>
        </div>
        <div
          v-for="item in Object.keys(showcaseItems)"
          :key="item"
          class="nav-item-dropdown"
        >
          <button class="products-link" @click.stop="handleProductsClick(item)">
            {{ item }}
            <RiArrowRightSLine size="20px" class="add" />
          </button>
        </div>
        <!-- <NuxtLink to="/about" prefetch-on="visibility">About us</NuxtLink> -->
        <NuxtLink to="/docs" prefetch-on="visibility">Docs</NuxtLink>
        <!-- <NuxtLink
        to="/pricing"
        prefetch-on="visibility"
        v-if="miraStore.country !== 'IN'"
        >Pricing</NuxtLink
      > -->

        <!-- <NuxtLink to="/partnership" prefetch-on="visibility"
        >Partnerships</NuxtLink
      > -->
        <NuxtLink to="/explore" prefetch-on="visibility"
          >Explore
          <span class="fire"
            ><img
              src="https://images.emojiterra.com/google/noto-emoji/unicode-16.0/color/svg/1f525.svg"
              alt="" ></span
        ></NuxtLink>
        <a
          target="_blank"
          rel="noopener noreferrer"
          @click="handleOsBasedRedirection"
          >Login</a
        >
        <div class="download-buttons">
          <button
            class="download-app-btn android"
            type="button"
            aria-label="Download on Google Play"
            @click="openPlayStore"
          >
            <RiAndroidFill size="16px" />
            Android
          </button>
          <button
            class="download-app-btn ios"
            type="button"
            aria-label="Download on App Store"
            @click="openAppStore"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
              <path
                d="M18.71,19.5C17.88,20.74 17,21.95 15.66,21.97C14.32,22 13.89,21.18 12.37,21.18C10.84,21.18 10.37,21.95 9.1,22C7.79,22.05 6.8,20.68 5.96,19.47C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.09,16.67C20.06,16.74 19.67,18.11 18.71,19.5M13,3.5C13.73,2.67 14.94,2.04 15.94,2C16.07,3.17 15.6,4.35 14.9,5.19C14.21,6.04 13.07,6.7 11.95,6.61C11.8,5.46 12.36,4.26 13,3.5Z"
              />
            </svg>
            iOS
          </button>

          <NuxtLink
            to="/#book-a-demo"
            class="download-app-btn demo"
            aria-label="Book a demo"
            @click="closeMenu"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#E864DA">
              <path
                d="M19,4H18V2H16V4H8V2H6V4H5C3.89,4 3,4.9 3,6V20A2,2 0 0,0 5,22H19A2,2 0 0,0 21,20V6A2,2 0 0,0 19,4M19,20H5V10H19V20M19,8H5V6H19V8Z"
              />
            </svg>
            <img src="~/public/book-a-demo.svg" alt="Book a demo" >
          </NuxtLink>
        </div>
      </nav>
      <ProductShowcase
        :show="showProducts"
        :announcement-hidden="isScrolled"
        :items="showcaseItems[hoverElement]"
        :is-info="hoverElement === 'products'"
        @mouseenter="handleProductsHover(true, hoverElement)"
        @mouseleave="handleProductsHover(false, hoverElement)"
        @close="closeProducts"
        @close-menu="((menu = false), (showProducts = false))"
      />
    </div>
  </div>
  <CookiesOverlay v-if="!isApp && !cookies && false" @click="saveAcceptTime" />
</template>
<script setup>
import {
  RiMenu2Line,
  RiCloseLine,
  RiArrowLeftLine,
  RiAndroidFill,
  RiArrowDownSLine,
  RiArrowRightSLine,
  RiImageEditLine,
  RiCamera3Line,
  RiBuildingLine,
  RiSuitcaseLine,
  RiTeamLine,
  RiGroup3Line,
} from "@remixicon/vue";
import logger from "debug";
import ProductShowcase from "./ProductShowcase.vue";
import { useMiraStore } from "~/store/mira";
import { useViewerStore } from "~/store/viewer";
import { useLocalStorage } from "@vueuse/core";
import { directive as vClickAway } from "vue3-click-away";
const { $device, $isIPhone, $isMobile } = useNuxtApp();
const debug = logger("travvir:debut-nuxt:components:Navbar");

const miraStore = useMiraStore();
const viewerStore = useViewerStore();
debug(miraStore.country, "country");

//variables
const menu = ref(false);
const cookies = ref(null);
const isScrolled = ref(false);
const config = useRuntimeConfig();

const showProducts = ref(false);
const hoverElement = ref(null);
let hoverTimeout = null;

function handleProductsHover(isHovering, element) {
  if (viewerStore.isPortrait) return;
  hoverElement.value = element;
  if (hoverTimeout) {
    clearTimeout(hoverTimeout);
    hoverTimeout = null;
  }

  if (isHovering) {
    showProducts.value = true;
  } else {
    hoverTimeout = setTimeout(() => {
      showProducts.value = false;
    }, 200);
  }
}

const showcaseItems = {
  products: [
    {
      title: "Spatial Replica",
      desc: "Generate a replica of any space from smartphone scans.",
      icon: RiCamera3Line,
      redirect: "#virtual-tour",
      image:
        "https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=800&auto=format&fit=crop",
      tag: "Pro",
      externalLink: false,
    },
    {
      title: "Spatial Media",
      desc: "AI generated reels, short videos & listing-grade photos.",
      icon: RiCamera3Line,
      redirect: "#reels",
      image:
        "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=800&auto=format&fit=crop",
      externalLink: false,
    },
    {
      title: "Spatial Layouts",
      desc: "AI generated 3D room layouts & floor plans.",
      icon: RiImageEditLine,
      redirect: "#room-layouts",
      image:
        config.public.NUXT_CDN_URL + "/static/images/livingroom-layout.jpeg",
      externalLink: false,
    },
    {
      conversationalProducts: [
        {
          title: "Mira AI",
          desc: "Let Mira showcase your space to customers 24*7",
          image:
            "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?q=80&w=800&auto=format&fit=crop",
          redirect: "#mira",
          tag: "New",
          externalLink: false,
        },
      ],
    },
  ],
  company: [
    {
      title: "About us",
      icon: RiBuildingLine,
      desc: "Our mission, values, and leadership",
      redirect: "about",
      externalLink: false,
    },
    {
      title: "Careers",
      icon: RiSuitcaseLine,
      desc: "Join us in building cutting-edge AI systems",
      redirect: "#join-us",
      externalLink: false,
    },
    {
      title: "Clients",
      icon: RiTeamLine,
      desc: "Truted by global enterprises",
      redirect: "#clients",
      externalLink: false,
    },
    {
      title: "Partnerships",
      icon: RiGroup3Line,
      desc: "Driving joint growth through strategic collaboration",
      redirect: "partnership",
      externalLink: false,
    },
    {
      title: "Blog",
      icon: RiImageEditLine,
      desc: "Guides, tutorials, and product updates",
      redirect: `${config.public.NUXT_BASE_URL}/blog/`,
      externalLink: true,
    },
  ],
};

function handleProductsClick(element) {
  showProducts.value = !showProducts.value;
  hoverElement.value = element;
}

function closeProducts() {
  showProducts.value = false;
}

const browserInfo = ref({ os: "Unsupported" });

//computed
const isApp = computed(() => $device.isAndroidApp || $device.isIosApp);

//methods
function closeMenu() {
  menu.value = false;
  showProducts.value = false;
}

function onClickAway(event) {
  const productShowcase = document.querySelector(".product-showcase");
  if (productShowcase && productShowcase.contains(event.target)) {
    return;
  }
  const target = event.target;
  if (
    target.closest(".nav-item-dropdown") ||
    target.closest(".products-link")
  ) {
    return;
  }

  closeMenu();
}

function saveAcceptTime() {
  let val = JSON.stringify({ acceptedOn: new Date() });
  useLocalStorage("terms_accept_time", val);
  cookies.value = val;
}

function browser() {
  if (import.meta.client) {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var os = detectOs(userAgent);
    return { os: os };
  }
}
function detectOs(agent) {
  if (navigator.userAgentData) return navigator.userAgentData.platform;
  else if (agent.includes("iPhone")) return "iOS";
  else if (agent.includes("Safari") && !agent.includes("Chrome"))
    return "MacOS";
  return "Unsupported";
}

function openAppStore() {
  window.open(
    "https://apps.apple.com/in/app/travvir-360-views-from-phone/id6443536819",
    "_blank",
  );
}

function openPlayStore() {
  window.open(
    "https://play.google.com/store/apps/details?id=com.travvir.studio",
    "_blank",
  );
}

function handleOsBasedRedirection() {
  if ($isMobile) {
    if ($isIPhone) openAppStore();
    else openPlayStore();
  } else {
    window.open(`${config.public.NUXT_BASE_URL}/app/auth/login`, "_blank");
  }
}

function handleScroll() {
  isScrolled.value = window.scrollY > 50;
}

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
  cookies.value = useLocalStorage("terms_accept_time", null);
  browserInfo.value = browser();
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
  if (hoverTimeout) {
    clearTimeout(hoverTimeout);
  }
});
</script>
<style scoped lang="scss">
.navbar-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.1);
}

.announcement-bar {
  overflow: hidden;
  max-height: 3rem;
  transition: max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 0;

  &__inner {
    transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    will-change: transform;
  }

  &--hidden {
    max-height: 0;

    .announcement-bar__inner {
      transform: translateY(-100%);
    }
  }
}

.header {
  position: relative;
  z-index: 1;
  width: 100%;
  display: flex;
  height: fit-content;
  justify-content: space-between;
  align-items: center;
  padding: 0 0rem;
  color: #fff;
  background: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  // transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: $theme-font;
  &.productShowcaseVisible {
    background: rgba(0, 0, 0, 0.98);
    border-bottom: none;
    height: 100%;
    &.scrolled {
      height: fit-content;
      background: rgba(0, 0, 0, 0.98);
      border-bottom: none;
      backdrop-filter: unset;
      -webkit-backdrop-filter: unset;
    }
    &.selected_container {
      height: fit-content;
      background: rgba(0, 0, 0, 0.98);
      backdrop-filter: unset;
      -webkit-backdrop-filter: unset;
    }
  }
  &.scrolled {
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  }
  &.selected_container {
    background: rgba(0, 0, 0, 0.05);
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
    padding: 0.2rem 3rem;

    @include respond-below(lg) {
      padding: 0.5rem 1rem;
      padding-right: 0.5rem;
    }
    .left-side {
      display: flex;
      align-items: center;
      gap: 1rem;
      @include respond-below(lg) {
        width: 100%;
        gap: 0.4rem;
      }
      .nav-item-dropdown {
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;

        .products-link {
          text-transform: capitalize;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 0.2rem;
          padding: 0.4rem 0.9rem !important;
          font-size: 14px !important;
          font-family: $theme-font;
          padding-right: 0rem !important;
          border-radius: 10px;
          font-weight: 400 !important;
          transition: all 0.3s ease;
          position: relative;

          &::before {
            content: "";
            position: absolute;
            bottom: 0;
            left: 50%;
            width: 0;
            height: 2px;
            background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
            transition: all 0.3s ease;
            transform: translateX(-50%);
          }

          .add {
            display: none;
          }

          &:hover {
            transform: translateY(-1px) !important;

            &::before {
              width: 80%;
            }
          }
          &.active-products-hover {
            transform: translateY(-1px) !important;

            &::before {
              width: 80%;
            }
          }

          svg {
            transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            opacity: 0.9;
            &.rotate-180 {
              transform: rotate(180deg);
            }
          }
        }
        @include respond-below(lg) {
          display: none;
          .products-link {
            &:hover {
              transform: none !important;
              background: transparent !important;
            }
          }
        }
      }
      a {
        cursor: pointer;
        font-size: 0.875rem;
        display: flex;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        text-decoration: unset;
        padding: 0.25rem 0.5rem;
        border-radius: 6px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;

        &:hover {
          color: #fff;
          transform: translateY(-1px);
        }

        &:before {
          content: "";
          position: absolute;
          bottom: 0;
          left: 50%;
          width: 0;
          height: 2px;
          background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
          transition: all 0.3s ease;
          transform: translateX(-50%);
        }
        &.router-link-active:before {
          width: 80%;
        }
        &.active:before {
          width: 80%;
        }

        &:hover:before {
          width: 80%;
        }

        @include respond-below(lg) {
          display: none;
          padding: 0.2rem 0.4rem;
          border-radius: 4px;
          font-size: 0.75rem;
          &:hover {
            transform: none !important;
            color: rgba(255, 255, 255, 1) !important;
          }
          &:hover:before {
            width: 0 !important;
          }
        }
      }
      .logo {
        color: white;
        text-decoration: none;
        @extend %v-center;
        text-decoration: none;
        height: auto;
        letter-spacing: -0.02rem;
        font-size: 1.6rem;
        font-weight: 600;
        background: linear-gradient(135deg, #fff 0%, #f0f0f0 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        transition: all 0.3s ease;
        &::before {
          background: none;
        }
        &:hover {
          transform: scale(1.02);
        }

        @include respond-below(lg) {
          font-size: 1.4rem;
          font-weight: 600;
          &:hover {
            transform: none !important;
          }
          svg {
            position: absolute;
          }
        }
      }
      .demo {
        width: fit-content;
        background: transparent;
        border: 1px solid rgba(255, 255, 255, 0.2);
        outline: none;
        color: white;
        font-size: 0.75rem;
        font-weight: 400;
        padding: 0.35rem 0.6rem;
        border-radius: 6px;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: none;
        font-family: inherit;
        min-width: 70px;
        display: none;
        align-items: center;
        gap: 0.4rem;
        margin-left: auto;
        @include respond-below(lg) {
          display: flex;
          justify-content: center;
          // border: ;
          padding-right: 0rem !important;
          padding-inline: 0.1rem;
          text-align: center;
          img {
            width: 90%;
          }
          &::before {
            background: none;
          }
          svg {
            display: none;
          }
          &:hover {
            transform: none !important;
            background: transparent !important;
            border-color: rgba(255, 255, 255, 0.3) !important;
          }
        }
        &:hover {
          transform: translateY(-1px) scale(1.02);
          background: rgba(255, 255, 255, 0.1);
          border-color: rgba(255, 255, 255, 0.5);
        }
      }
    }

    .short-cut {
      a {
        font-size: 0.875rem;
        display: none;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        text-decoration: unset;
        padding: 0.25rem 0.5rem;
        border-radius: 6px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;

        &:hover {
          color: #fff;
          transform: translateY(-1px);
        }

        &:before {
          content: "";
          position: absolute;
          bottom: 0;
          left: 50%;
          width: 0;
          height: 2px;
          background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
          transition: all 0.3s ease;
          transform: translateX(-50%);
        }
        &.router-link-active:before {
          width: 80%;
        }
        &.active:before {
          width: 80%;
        }

        &:hover:before {
          width: 80%;
        }

        @include respond-below(lg) {
          padding: 0.2rem 0.4rem;
          border-radius: 4px;
          font-size: 0.75rem;
          &::before {
            background: none;
          }
        }
      }
      .demo {
        &::before {
          background: none;
        }
      }
      .top {
        display: none;
      }
      .nav-item-dropdown {
        position: relative;
        height: 100%;
        display: none;
        align-items: center;
        margin-right: 0.5rem;

        .products-link {
          text-transform: capitalize;
          display: flex;
          align-items: center;
          gap: 0.4rem;
          padding: 0.4rem 0.9rem !important;
          border-radius: 10px;
          font-weight: 400 !important;
          transition: all 0.3s ease;
          position: relative;

          &::before {
            content: "";
            position: absolute;
            bottom: 0;
            left: 50%;
            width: 0;
            height: 2px;
            background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
            transition: all 0.3s ease;
            transform: translateX(-50%);
          }

          .add {
            display: block;
          }

          .arrow {
            display: none;
          }

          &:hover {
            transform: translateY(-1px) !important;

            &::before {
              width: 80%;
            }
          }

          svg {
            transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            opacity: 0.9;
            &.rotate-180 {
              transform: rotate(180deg);
            }
          }
        }
      }

      .book-a-demo {
        display: none;
      }

      .download-buttons {
        display: flex;
        gap: 0.5rem;
        align-items: center;

        @include respond-below(lg) {
          display: none;
          flex-direction: column;
          width: calc(100% - 3rem);
          gap: 0.3rem;
        }
        .demo {
          svg {
            color: red;
          }
        }
      }

      .download-app-btn {
        background: transparent;
        border: 1px solid rgba(255, 255, 255, 0.3);
        outline: none;
        color: white;
        font-size: 0.875rem;
        font-weight: 400;
        padding: 0.35rem 0.6rem;
        border-radius: 6px;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: none;
        font-family: inherit;
        min-width: 70px;
        display: flex;
        align-items: center;
        gap: 0.4rem;

        svg {
          flex-shrink: 0;
        }

        &:hover {
          transform: translateY(-1px) scale(1.02);
          background: rgba(255, 255, 255, 0.1);
          border-color: rgba(255, 255, 255, 0.5);
        }

        &:active {
          transform: translateY(0) scale(1.01);
        }

        &.ios {
          svg {
            color: white;
          }
        }

        @include respond-below(lg) {
          padding: 0.8rem 1.2rem;
          font-size: 1rem;
          width: 100%;
          border-radius: 10px;
          justify-content: center;
          gap: 0.6rem;
          &:hover {
            transform: none !important;
            background: transparent !important;
            border-color: rgba(255, 255, 255, 0.3) !important;
          }

          svg {
            width: 18px;
            height: 18px;
          }
        }
      }
    }
  }

  @include respond-below(sm) {
    justify-content: space-between;
    padding: 0 1rem;
    height: 2.5rem;

    &.scrolled {
      height: 2.25rem;
    }
  }

  .logo {
    color: white;
    text-decoration: none;
    font-size: 1.3rem;
    letter-spacing: -0.01rem;
    font-weight: 600;
    background: linear-gradient(135deg, #fff 0%, #f0f0f0 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    transition: all 0.3s ease;
    display: block;

    &:hover {
      transform: scale(1.02);
    }

    @include respond-below(sm) {
      font-size: 1.1rem;
      &:hover {
        transform: none !important;
      }
    }
  }

  .short-cut {
    @extend %flex-center;
    gap: 1.2rem;
    @extend %chat-text;

    a {
      font-size: 0.875rem;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.9);
      text-decoration: none;
      cursor: pointer;
      padding: 0.25rem 1rem;
      border-radius: 6px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;

      &:hover {
        color: #fff;
        transform: translateY(-1px);
      }

      &.capture-btn {
        color: #fff;

        &:hover {
          transform: translateY(-1px);
        }
      }

      &.login-btn {
        &:hover {
          border-color: rgba(255, 255, 255, 0.6);
        }
      }
    }

    &.open {
      display: revert;
      position: fixed;
      top: 0;
      left: 0;
      width: 90vw;
      height: 100vh;
      @supports not (height: 100vh) {
        height: 100%;
      }
      inset: 0;
      z-index: 111;
      background: rgba(0, 0, 0, 0.95);
      backdrop-filter: blur(20px);
      -webkit-backdrop-filter: blur(20px);
      display: flex;
      justify-content: start;
      padding-top: 1rem;
      align-items: start;
      flex-flow: wrap column;
      animation: slide-menu 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;
      box-shadow: 0 0 50px rgba(0, 0, 0, 0.1);
      .book-a-demo {
        display: block;
        color: rgba(255, 255, 255, 0.8);
      }
      .top {
        display: flex;
        align-items: center;
        gap: 1rem;
        width: 100%;
        a {
          padding: 0rem;
          padding-left: 1.3rem;
          font-size: 1.8rem;
          line-height: 100%;
          text-transform: capitalize;
          &:hover {
            transform: none !important;
            background: transparent !important;
            color: rgba(255, 255, 255, 0.8) !important;
            -webkit-text-fill-color: rgba(255, 255, 255, 0.8) !important;
          }
          &:before {
            display: none !important;
          }
          svg {
            position: absolute;
            left: -0.1rem;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        .products {
          margin-left: 0.4rem;
          font-size: 1.8rem;
        }
      }

      a {
        color: rgba(255, 255, 255, 0.8);
        padding: 0.8rem 1.5rem;
        margin: 0.3rem 0;
        display: flex;
        font-size: 1.1rem;
        font-weight: 500;
        border-radius: 12px;
        width: calc(100% - 3rem);
        transition: all 0.3s ease;

        @include respond-below(lg) {
          &:hover {
            background: none !important;
            color: rgba(255, 255, 255, 0.8) !important;
            transform: none !important;
          }
        }

        &:hover {
          background: rgba(102, 126, 234, 0.1);
          color: #667eea;
          transform: translateX(8px);
        }

        &.capture-btn {
          color: inherit;
        }
        &.book-a-demo {
          display: block;
          color: rgba(255, 255, 255, 0.8);
        }
      }
      .nav-item-dropdown {
        height: fit-content;
        display: flex;
        width: 100%;
        margin-right: 0rem;
        .products-link {
          cursor: pointer;
          padding: 0.8rem 1.5rem !important;
          line-height: 90%;
          font-size: 1.1rem;
          color: rgba(255, 255, 255, 0.8);
          font-weight: 500 !important;
          width: 100%;
          &::before {
            display: none;
          }
          .add {
            display: block;
          }
          .arrow {
            display: none;
          }
        }
      }

      @keyframes slide-menu {
        from {
          left: -100%;
          opacity: 0;
        }
        to {
          left: 0;
          opacity: 1;
        }
      }

      .icon {
        cursor: pointer;
        position: relative;
        margin-left: auto;
        margin-right: 1.4rem;
        color: #fff;
        padding: 0.1rem;
        border-radius: 8px;
        transition: all 0.3s ease;

        @include respond-below(lg) {
          &:hover {
            background: transparent !important;
          }
        }

        &:hover {
          background: rgba(0, 0, 0, 0.1);
        }
      }
    }

    @include respond-below(lg) {
      display: none;
      gap: 0.6rem;
      a {
        font-size: 0.75rem;
      }
    }
  }
}

.menu-options {
  display: none;
  @include respond-below(lg) {
    gap: 0.7rem;
    display: flex;
    align-items: center;
  }
  button {
    height: fit-content;
    padding-top: 0.3rem;
  }

  svg {
    cursor: pointer;
    padding: 0.1rem;
    border-radius: 8px;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
      transform: scale(1.1);
    }
  }
}

.search {
  @include respond-below(sm) {
    .search-dropdown {
      display: none;
    }
  }

  &.open {
    animation: slide-left 400ms cubic-bezier(0.4, 0, 0.2, 1) forwards;
    padding: 0.5rem 1rem;
    align-items: center;
    display: flex;
    flex-direction: row-reverse;
    background: rgba(0, 0, 0, 0.9);
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
    gap: 1rem;
    left: 0%;
    width: 100%;
    position: absolute;
    border-radius: 0 0 16px 16px;

    .search-dropdown {
      display: flex;
    }
  }
}
button {
  border: none;
  outline: none;
  background: transparent;
  color: inherit;
}

@keyframes slide-left {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.hidden {
  display: none !important;
}
.fire {
  width: auto;
  margin-left: 0.25rem;
  align-items: center;
  display: inline-flex;
  img {
    width: 1rem;
    height: 1rem;
    vertical-align: middle;
  }
}
</style>
